import { NgModule } from '@angular/core';
import { iBisCommonModule } from '@dohu/ibis-common';
import { BrowserModule } from '@angular/platform-browser';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { iBisAuthModule, iBisEditUserService } from '@dohu/ibis-auth';
import { LocationComponent } from './location/location.component';
import { UserComponent } from './user/user.component';
import { DxValidationGroupModule } from 'devextreme-angular/ui/validation-group';

@NgModule({
	declarations: [
        LocationComponent,
        UserComponent
	],
	imports: [
		BrowserModule,
		iBisAuthModule,
		DxDataGridModule,
        DxValidationGroupModule,
		iBisCommonModule,
	],
	exports: [
        LocationComponent,
        UserComponent
	],
	providers: [
		iBisEditUserService,
	]
})
export class AdminModule { }
